export const schedulingLabels = {
	scheduleScans: 'Schedule Scans',
	runScanEvery: 'Run scan every',
	amount: 'Select amount',
	periodType: 'Select period type',
	daysToRunScan: 'Days to run scan',
	time: 'Time',
	timezone: 'Timezone',
	startMonth: 'Start Month',
	startTime: 'Start time',
	months: 'month',
	weeks: 'week',
	scheduleScansDescription: 'Run scans automatically on selected days each week or month.',
	runEvery: 'Run scan every',
	crawlBeforeScan: 'Crawl before scanning',
	nextScanScheduledFor: 'Next scan is scheduled for',
	at: 'at'
};
